import { QuizContext } from 'components/MainComponent/MainComponent'
import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import RightOrWrong from './RightOrWrong'
import UserMistakes from './UserMistakes'
import ProductEvaluation from './ProductEvaluation'
import Kehricht from './Kehricht'
import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import { useWindowSize } from 'usehooks-ts'

const Evaluation = ({
  userAnswers,
  colorMode,
}: {
  userAnswers: Answer[]
  colorMode?: 'light' | 'dark' | undefined
}) => {
  const context = useContext(QuizContext)
  const [allUserRatio, setAllUserRatio] = useState<{
    correct: number
    wrong: number
  }>()
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712
  const [allUserCount, setAllUserCount] = useState<number>()

  const wrongAnswers = userAnswers.filter((f) => !f.correct)

  useEffect(() => {
    if (!context.dbData) return
    if (context.dbData.allUserRatio) {
      setAllUserRatio(context.dbData.allUserRatio)
    }
    if (context.dbData.allUserCount) {
      setAllUserCount(context.dbData.allUserCount)
    }
  }, [context])

  return (
    <>
      <TextWidth>
        <EvaluationContainer>
          {allUserRatio && allUserCount && (
            <RightOrWrong
              userTotal={userAnswers.length}
              userCorrect={getCorrectPercent(userAnswers)}
              participantsCorrect={allUserRatio.correct}
              participantsCount={allUserCount}
            />
          )}
        </EvaluationContainer>
      </TextWidth>
      <>
        {wrongAnswers.length > 0 && (
          <UserMistakes
            isMobile={isMobile}
            wrongAnswers={wrongAnswers}
            colorMode={colorMode}
          />
        )}
      </>

      <TextWidth>
        <EvaluationContainer>
          {context.dbData && context.dbData.items && (
            <ProductEvaluation
              products={context.dbData.items as DBItems}
              participantsCount={allUserCount}
              type='worst'
            />
          )}
          {context.dbData && context.dbData.items && (
            <ProductEvaluation
              products={context.dbData.items as DBItems}
              participantsCount={allUserCount}
              type='best'
              hideFalse
            />
          )}
        </EvaluationContainer>
      </TextWidth>

      {context.dbData && context.dbData.items && (
        <Kehricht products={context.dbData.items as DBItems} />
      )}
    </>
  )
}
const EvaluationContainer = styled.div``

export default Evaluation

function getCorrectPercent(answers: Answer[]) {
  const total = answers.length
  const correct = answers.filter((a) => a.correct).length
  return (correct * 100) / total
}
